import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

import { AppUtils } from '../../shared/helpers/app.utils';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
    providedIn: 'root'
})
export class NavigationGuard implements CanDeactivate<CanComponentDeactivate> {

    constructor(private readonly appUtils: AppUtils) {
        this.appUtils.navigationHistoryClean();
    }

    canDeactivate(
        component: CanComponentDeactivate
    ): Observable<boolean> | Promise<boolean> | boolean {
        return component.canDeactivate ? component.canDeactivate() : true;
    }
}
